<template>
  <div>

    <!-- status icon -->
    <template v-if="status">
      <template v-if="status.type == 'icon'">
        <vs-tooltip
          :text="status.text"
          style="float: left;margin: 0px 5px 0 0;"
          position="top">
          <i
            :class="'fas fa-circle' + ' text-' + status.color"
            style="font-size: 9px;position: relative;top: -2px;"/>
        </vs-tooltip>
      </template>
    </template>
    <!-- link -->
    <slot v-if="$slots.default"/>
    <template v-else>
      <span
        v-if="!checkAuth({app_id: to_appid}) || disabled"
        :class="[{'opacity30': disabled}]">
        {{ text }}
      </span>
      <router-link
        v-else-if="checkAuth({app_id: to_appid})"
        :to="to">
        {{ text }}
      </router-link>
    </template>

    <!-- status message -->
    <template v-if="status">
      <template v-if="status.type == 'message'">
        <span :class="'badge link-status ' + ' badge-'+status.color">
          {{ status.text }}
        </span>
      </template>
    </template>

  </div>
</template>
<script>
export default {
  props: {
    to_appid: {
      type: Number,
    },
    current_appid: {
      type: Number,
    },
    to: {
      type: Object,
    },
    icon: {
      type: Object,
    },
    text: {
      type: String,
      default: '',
    },
    status: {
      type: Object,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
.link {
  color: var(--link-color);
}
.link-status {
  position: relative;
  top: -2px;
  font-size: 9px;
  padding: 3px 6px 3px 5px;
}
.opacity30 {
  opacity: 0.3;
}
</style>



// WEBPACK FOOTER //
// src/components/custom/Link.vue